import React from 'react';
import { SubtleTagline } from '../styles';
const SupportTagline = props => {
  const {
    supportDetails: {
      isSupported,
      hasResources,
      partner,
      contact: {
        issueTrackerUrl,
        statusPageUrl,
        supportTicketSystemUrl,
        websiteUrl
      }
    }
  } = props;
  const taglineProps = {
    centered: true,
    as: 'h2'
  };
  const hasIssueTrackingResources = issueTrackerUrl || statusPageUrl || supportTicketSystemUrl || websiteUrl;
  if (partner.name && isSupported) {
    return /*#__PURE__*/React.createElement(SubtleTagline, taglineProps, partner.name, " provides support for this app");
  }
  if (hasResources || hasIssueTrackingResources) {
    return /*#__PURE__*/React.createElement(SubtleTagline, taglineProps, "Basic support resources are available for this app.");
  }
  return /*#__PURE__*/React.createElement(SubtleTagline, taglineProps, "Support is not available for this app.");
};
export default SupportTagline;